export default theme => ({
  loadingLoader: {
    padding: '40px 0',
    textAlign: 'center'
  },
  advice: {
    marginBottom: 10
  },
  adviceError: {
    marginBottom: 10,
    '& span': {
      color: `${theme.colors.semantic.negative500} !important`
    },
    '& > div': {
      height: 'auto !important'
    }
  },
  adviceWarning: {
    marginBottom: 10,
    '& span': {
      color: `${theme.colors.semantic.focus500} !important`
    },
    '& > div': {
      height: 'auto !important'
    }
  },
  errorList: {
    height: '400px !important',
    overflow: 'hidden',
    '& .ag-header-viewport .ag-header-cell': {
      '&::after': {
        border: 'none !important'
      }
    },
    '@media (max-height: 700px)': {
      height: '400px !important'
    }
  },
  errorTitle: {
    display: 'flex',
    alignItems: 'center'
  },
  arrowIcon: {
    marginRight: 10
  },
  linkError: {
    padding: 0,
    color: theme.colors.semantic.negative500,
    textDecoration: 'underline',
    fontWeight: 'bold',
    '&:hover': {
      color: theme.colors.semantic.negative500
    }
  },
  linkWarning: {
    padding: 0,
    color: theme.colors.semantic.focus500,
    textDecoration: 'underline',
    fontWeight: 'bold',
    '&:hover': {
      color: theme.colors.semantic.focus500
    }
  },
  iconDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed'
  },
  adviceLiterals: {
    display: 'inline-block',
    whiteSpace: 'pre-wrap'
  }
});